
export function config(key: string): any {
    return window.config[key];
}
